<template>
  <div class="preview-page">
    <div class="preview-header">
      <a href="javascript:;" :class="{active: activeTab === 'phone'}" @click="previewPhone">手机预览</a>
      <a href="javascript:;" :class="{active: activeTab === 'pc'}" @click="previewPc">电脑预览</a>
      <a href="javascript:;" class="back-btn" @click="handleBack">返回</a>
    </div>
    <div class="preview-main">
      <div v-show="activeTab === 'phone'" class="preview-in-phone">
        <iframe :src="previewUrl" class="previewIframe" frameborder="0" name="preview_frame"></iframe>
      </div>
      <div v-show="activeTab === 'pc'" class="preview-in-pc">
        <iframe :src="previewUrl" class="previewPcIframe" frameborder="0" name="preview_frame"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Preview',
  data() {
    return {
      activeTab: 'phone',
    };
  },
  computed: {
    previewUrl() {
      return window.sessionStorage.getItem('previewUrl');
    }
  },
  methods: {
    previewPhone() {
      this.activeTab = 'phone';
    },
    previewPc() {
      this.activeTab = 'pc';
    },
    handleBack() {
      history.go(-1);
    },
  },
};
</script>

<style lang="scss">
.preview-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #F0F0F0;
  z-index: 99;
  .preview-header {
    height: 70px;
    line-height: 70px;
    font-size: 0;
    text-align: center;
    background-color: #FFF;
    a {
      color: #666;
      padding: 0 25px;
      font-size: 18px;
      &:hover, &.active {
        color: #FF552E;
      }
      &:first-child {
        border-right: 1px solid #ccc;
      }
    }
    .back-btn {
      float: right;
      font-size: 18px;
      font-weight: normal;
      line-height: 70px;
      color: #888;
    }
  }
  .preview-main {
    height: calc(100% - 70px);
    overflow-y: auto;
    .previewIframe {
      position: absolute;
      width: 320px;
      height: 570px;
      top: 89px;
      left: 19px;
    }
    .previewPcIframe {
      width: 100%;
      height: 100%;
    }
  }
  .preview-in-pc {
    height: 100%;
  }
  .preview-in-phone {
    background-image: url(../assets/bg_phone.png);
    width: 388px;
    height: 790px;
    margin: 50px auto;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/preview.vue